import { amazonHost } from "../../../../paths";

export default (path: string) => {
    return amazonHost + "birds" + path;
};
